<template>
  <page>
    <div :load="doInit">
      <v-expansion-panels v-model="panel" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div><v-icon>mdi-filter-variant</v-icon> Report Type</div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-sm>
                  <v-layout row wrap>
                    <v-flex xs12 sm6 md6 lg6>
                      <v-autocomplete
                        :items="reportTypes"
                        v-model="reportForm.reportType"
                        :label="labels.reportType"
                        item-text="label"
                        item-value="value"
                        data-vv-name="reportType"
                        :data-vv-as="labels.reportType"
                        :error-messages="errors.collect('reportType')"
                        v-validate="'required'"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm6 md6 lg6> </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-spacer class="mt-2"></v-spacer>
      <v-expansion-panels v-model="panel1" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div><v-icon>mdi-filter-variant</v-icon> Date Range</div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                <v-form>
                  <v-container fluid grid-list-sm>
                    <v-layout row wrap>
                      <v-flex xs6>
                        <cal-picker
                          v-model="reportForm.tranDateFrom"
                          :label="labels.tranDateFrom"
                          v-validate="fromDateValidation(reportForm.tranDateTo)"
                          :data-vv-as="labels.tranDateFrom"
                          data-vv-name="tranDateFrom"
                          :error-messages="errors.collect('tranDateFrom')"
                          :max="reportForm.tranDateTo"
                          :disabled="reportForm.reportType == 'stats'"
                        ></cal-picker>
                      </v-flex>
                      <v-flex xs6>
                        <cal-picker
                          v-model="reportForm.tranDateTo"
                          :label="labels.tranDateTo"
                          v-validate="toDateValidation(reportForm.tranDateFrom)"
                          :data-vv-as="labels.tranDateTo"
                          data-vv-name="tranDateTo"
                          :error-messages="errors.collect('tranDateTo')"
                          :min="reportForm.tranDateFrom"
                          :max="today"
                          :disabled="reportForm.reportType == 'stats'"
                        ></cal-picker>
                      </v-flex>
                      <v-flex xs6>
                        <cal-picker
                          v-model="reportForm.uwTranDateFrom"
                          :label="labels.uwTranDateFrom"
                          v-validate="fromDateValidation(reportForm.uwTranDateTo)"
                          :data-vv-as="labels.uwTranDateFrom"
                          data-vv-name="uwTranDateFrom"
                          :error-messages="errors.collect('uwTranDateFrom')"
                          :max="reportForm.uwTranDateTo"
                          :disabled="reportForm.reportType == 'execIC'"
                        ></cal-picker>
                      </v-flex>
                      <v-flex xs6>
                        <cal-picker
                          v-model="reportForm.uwTranDateTo"
                          :label="labels.uwTranDateTo"
                          v-validate="toDateValidation(reportForm.uwTranDateFrom)"
                          :data-vv-as="labels.uwTranDateTo"
                          data-vv-name="uwTranDateTo"
                          :error-messages="errors.collect('uwTranDateTo')"
                          :min="reportForm.uwTranDateFrom"
                          :max="today"
                          :disabled="reportForm.reportType == 'execIC'"
                        ></cal-picker>
                      </v-flex>
                      <v-flex xs6>
                        <cal-picker
                          v-model="reportForm.clmTranDateFrom"
                          :label="labels.clmTranDateFrom"
                          v-validate="fromDateValidation(reportForm.clmTranDateTo)"
                          :data-vv-as="labels.clmTranDateFrom"
                          data-vv-name="clmTranDateFrom"
                          :error-messages="errors.collect('clmTranDateFrom')"
                          :max="reportForm.clmTranDateTo"
                          :disabled="reportForm.reportType == 'execIC'"
                        ></cal-picker>
                      </v-flex>
                      <v-flex xs6>
                        <cal-picker
                          v-model="reportForm.clmTranDateTo"
                          :label="labels.clmTranDateTo"
                          v-validate="toDateValidation(reportForm.clmTranDateFrom)"
                          :data-vv-as="labels.clmTranDateTo"
                          data-vv-name="clmTranDateTo"
                          :error-messages="errors.collect('clmTranDateTo')"
                          :min="reportForm.clmTranDateFrom"
                          :max="today"
                          :disabled="reportForm.reportType == 'execIC'"
                        ></cal-picker>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-spacer class="mt-2"></v-spacer>
      <v-expansion-panels v-model="panel2" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-sm>
                  <v-layout row wrap>
                    <!-- Executive In-Charge(s) -->
                    <v-flex xs12 v-if="reportForm.reportType == 'execIC'">
                      <v-text-field
                        v-model="reportForm.execIC"
                        :label="labels.execIC"
                        :error-messages="errors.collect('execIC')"
                        :data-vv-as="labels.execIC"
                        data-vv-name="execIC"
                        append-icon="mdi-magnify"
                        @click:append="multiExecInChargeHelpList = true"
                        readonly
                      ></v-text-field>
                    </v-flex>
                    <!-- Account No.(s) -->
                    <v-flex xs12>
                      <v-text-field
                        v-model="reportForm.acctNo"
                        :label="labels.acctNo"
                        :error-messages="errors.collect('acctNo')"
                        :data-vv-as="labels.acctNo"
                        data-vv-name="acctNo"
                        append-icon="mdi-magnify"
                        @click:append="multiInterHelpList = true"
                        readonly
                      ></v-text-field>
                    </v-flex>
                    <!-- Business Class Group(s) -->
                    <v-flex xs12 v-if="reportForm.reportType == 'execIC'">
                      <v-text-field
                        v-model="reportForm.busClsGrp"
                        :label="labels.busClsGrp"
                        :error-messages="errors.collect('busClsGrp')"
                        :data-vv-as="labels.busClsGrp"
                        data-vv-name="busClsGrp"
                        append-icon="mdi-magnify"
                        @click:append="multiBusClsGrpHelpList = true"
                        readonly
                      ></v-text-field>
                    </v-flex>
                    <!-- Business Class(es) -->
                    <v-flex xs12 v-if="reportForm.reportType == 'execIC'">
                      <v-text-field
                        v-model="reportForm.busCls"
                        :label="labels.busCls"
                        :error-messages="errors.collect('busCls')"
                        :data-vv-as="labels.busCls"
                        data-vv-name="busCls"
                        append-icon="mdi-magnify"
                        @click:append="multiBusClsHelpList = true"
                        readonly
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-spacer class="mt-2"></v-spacer>
      <v-form>
        <v-container fluid grid-list-sm>
          <v-layout row wrap>
            <v-flex lg6 xs12>
              <v-btn class="mr-2" color="primary" type="submit" :loading="loading" @click.prevent="doExport">
                <v-icon left dark>mdi-file-export</v-icon>
                {{ labels.export }}
              </v-btn>
              <v-btn-toggle dense mandatory v-model="reportForm.format">
                <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                  <span>{{ format.label }}</span>
                  <v-icon :color="format.color">{{ format.icon }}</v-icon>
                </v-btn>
              </v-btn-toggle>
            </v-flex>
            <v-flex lg6 xs12>
              <v-checkbox dense v-model="reportForm.printRptRunTime" :label="labels.printRptRunTime" data-vv-name="printRptRunTime" :data-vv-as="labels.printRptRunTime"></v-checkbox>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </div>
    <!-- Account Helplist -->
    <v-dialog v-model="multiInterHelpList" width="900px" persistent>
      <multi-intermediary-help-list
        :intr="reportForm.acctNo"
        :intrGrp="intrGrp"
        :listName="'billAcctNoList'"
        helpListTitle="Billing Account No. Helplist"
        @close="doClose"
        @doAssign="doAssign('acctNo', $event)"
      ></multi-intermediary-help-list>
    </v-dialog>
    <!-- Executive In-Charge Helplist -->
    <v-dialog v-model="multiExecInChargeHelpList" width="900px" persistent>
      <multi-exec-in-charge-help-list
        :execic="reportForm.execIC"
        @close="doClose"
        @doAssign="doAssign('execIC', $event)"
      ></multi-exec-in-charge-help-list>
    </v-dialog>
    <!-- Business Class Group Helplist -->
    <v-dialog v-model="multiBusClsGrpHelpList" width="900px" persistent>
      <multi-bus-cls-grp-help-list
        :busClsGrp="reportForm.busClsGrp"
        @close="doClose"
        @doAssign="doAssign('busClsGrp', $event)"
      ></multi-bus-cls-grp-help-list>
    </v-dialog>
    <!-- Business Class Helplist -->
    <v-dialog v-model="multiBusClsHelpList" width="900px" persistent>
      <multi-bus-cls-help-list :busCls="reportForm.busCls" @close="doClose" @doAssign="doAssign('busCls', $event)"></multi-bus-cls-help-list>
    </v-dialog>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { checkDateRangeFrom, checkDateRangeTo } from '@/directives/common'
import MultiIntermediaryHelpList from '@/components/core/common/dialog/MultiIntermediaryHelpList.vue'
import MultiExecInChargeHelpList from '@/components/core/common/dialog/MultiExecInChargeHelpList.vue'
import MultiBusClsGrpHelpList from '@/components/core/common/dialog/MultiBusClsGrpHelpList.vue'
import MultiBusClsHelpList from '@/components/core/common/dialog/MultiBusClsHelpList.vue'

export default {
  data() {
    return {
      labels: {
        reportType: 'Report Type',
        dateRange: 'Date Ranges',
        tranDateFrom: 'From Transaction Date*',
        tranDateTo: 'To Transaction Date*',
        execIC: 'Executive In-charge(s)',
        acctNo: 'Billing Account(s)',
        busClsGrp: 'Business Class Group(s)',
        busCls: 'Business Class(es)',
        uwTranDateFrom: 'From Underwriting Transaction Date*',
        uwTranDateTo: 'To Underwriting Transaction Date*',
        clmTranDateFrom: 'From Claims Transaction Date*',
        clmTranDateTo: 'To Claims Transaction Date*',
        format: 'Export Format',
        export: 'Export to',
        printRptRunTime: 'Print report runtime parameters'
      },
      reportForm: {
        reportType: 'execIC',
        tranDateFrom: undefined,
        tranDateTo: undefined,
        execIC: 'All',
        acctNo: 'All',
        busClsGrp: 'All',
        busCls: 'All',
        uwTranDateFrom: undefined,
        uwTranDateTo: undefined,
        clmTranDateFrom: undefined,
        clmTranDateTo: undefined,
        format: undefined,
        printRptRunTime: true
      },
      reportTypes: [
        { label: 'Premium and Claims Summary by Executive In-charge', value: 'execIC' },
        { label: 'Premium and Claims Statistics', value: 'stats' }
      ],
      // HelpList
      multiInterHelpList: false,
      multiExecInChargeHelpList: false,
      multiBusClsGrpHelpList: false,
      multiBusClsHelpList: false,
      // Other
      today: new Date(),
      menu: {},
      supportedFormat: [],
      loading: false,
      intrGrp: '10,11,12,13,20,25',
      panel: [0],
      panel1: [0],
      panel2: [0]
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.uwReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.uwReports.menu !== 1) {
          await this.$store.dispatch('uwReportsInit')
        }
        const apiURI = this.rptMenu.initPremClmSumm
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result
          if (data) {
            this.supportedFormat = data.data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    doAssign(type, obj) {
      switch (type) {
        case 'execIC':
          this.reportForm.execIC = []
          this.reportForm.execIC = obj.finalSelectedItems.toString()
          break
        case 'acctNo':
          this.reportForm.acctNo = []
          this.reportForm.acctNo = obj.finalSelectedItems.toString()
          break
        case 'busClsGrp':
          this.reportForm.busClsGrp = []
          this.reportForm.busClsGrp = obj.finalSelectedItems.toString()
          break
        case 'busCls':
          this.reportForm.busCls = []
          this.reportForm.busCls = obj.finalSelectedItems.toString()
          break
      }
    },
    doClose() {
      this.multiExecInChargeHelpList = false
      this.multiInterHelpList = false
      this.multiBusClsHelpList = false
      this.multiBusClsGrpHelpList = false
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.exportPremClmSumm
      if (apiURI) {
        try {
          this.loading = true
          await this.$http.post(apiURI, this.reportForm)
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    fromDateValidation(toDate1) {
      if (toDate1) {
        return 'required|checkDateRangeFrom:' + toDate1
      } else {
        return 'required|checkDateRangeFrom'
      }
    },
    toDateValidation(fromDate1) {
      if (fromDate1) {
        return 'required|checkDateRangeTo:' + fromDate1
      } else {
        return 'required|checkDateRangeTo'
      }
    },
    fromUWDateValidation(toDate1) {
      if (toDate1) {
        return 'required|checkDateRangeFrom:' + toDate1
      } else {
        return 'required|checkDateRangeFrom'
      }
    },
    toUWDateValidation(fromDate1) {
      if (fromDate1) {
        return 'required|checkDateRangeTo:' + fromDate1
      } else {
        return 'required|checkDateRangeTo'
      }
    }
  },
  created() {
    this.doInit()
    this.$validator.extend('checkDateRangeFrom', checkDateRangeFrom)
    this.$validator.extend('checkDateRangeTo', checkDateRangeTo)
  },
  watch: {
    'reportForm.reportType': function(value) {
      if (value === 'execIC') {
        this.reportForm.uwTranDateFrom = undefined
        this.reportForm.uwTranDateTo = undefined
        this.reportForm.clmTranDateFrom = undefined
        this.reportForm.clmTranDateTo = undefined
      } else {
        this.reportForm.tranDateFrom = undefined
        this.reportForm.tranDateTo = undefined
      }
      this.reportForm.execIC = 'All'
      this.reportForm.acctNo = 'All'
      this.reportForm.busClsGrp = 'All'
      this.reportForm.busCls = 'All'
    }
  },
  mixins: [MessageMixin, commonAjaxMixin],
  components: {
    MultiIntermediaryHelpList,
    MultiExecInChargeHelpList,
    MultiBusClsGrpHelpList,
    MultiBusClsHelpList
  }
}
</script>
